// src/Redux/Sidebar/reducer.js
import { ACTION_TYPES } from 'Constants'

const initialState = {
  isOpen: true, // Sidebar is open by default
};

const sidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.TOGGLE_SIDEBAR:
      return { ...state, isOpen: !state.isOpen };
    default:
      return state;
  }
};

export default sidebarReducer;
